// src/plugins/axios.js
import axios from "axios";

const api = axios.create({
  // baseURL: 'http://localhost:8000/api',
  baseURL: "https://apachesc.wanorn.com/backend/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    // 'Authorization': `Bearer ${token}` // ถ้ามี token
  },
});

export default api;
